import { accountingName } from '../utils/accounting-name';


export let colAttachmentName = {colId: 'attachmentName', headerName: 'Attachment Name', field: 'name',width: 100 };
export let colVendorNum = {colId: 'vendorNum', headerName: 'Number', field: 'vendorNum',width: 100, sortable: true};
export let colVendorName = {
  colId: 'vendorName', headerName: 'Legal Name', field: 'name', width: 100, sortable: true,
  // Append a subtle "NetSuite" badge for parties imported from NetSuite (sourceSystem).
  // The name is HTML-escaped because a custom cellRenderer string bypasses AG-Grid's
  // default value escaping.
  cellRenderer: (params: any) => {
    const name = String(params.value ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    if (params.data?.sourceSystem === 'netsuite') {
      return `${name} <span style="margin-left:6px;padding:1px 7px;border:1px solid #b0bec5;border-radius:10px;font-size:10px;color:#546e7a;vertical-align:middle;">NetSuite</span>`;
    }
    return name;
  }
};
export let colAccountingCompanyName = {
  colId: 'accountingCompanyName',
  headerName: 'Accounting Company Name',
  // valueGetter, not `field`: the stored field is empty on every party, so the
  // column falls back to NetSuite's print-on-check-as. See `accountingName`.
  valueGetter: (params: any) => accountingName(params.data),
  width: 100,
  sortable: true
};
export let colWebsite = {colId: 'website', headerName: 'Website', field: 'website',width: 100, sortable: true };

export let colTin = { 
                      colId: 'tin',
                      headerName: 'TIN',
                      field: 'tin',
                      width: 50,
                      sortable: true
                    };

export let colSpecialty = { 
                            colId: 'specialty',
                            headerName: 'Specialty',
                            field: 'specialty',
                            width: 100,
                            sortable: true
                          };

export let colParentParty = { colId: 'parentParty',
                              headerName: 'Parent Vendor',
                              field: 'parentVendorFriendlyName',
                              width: 100,
                              sortable: true
                            };

export let colAddress = {colId: 'address', headerName: 'Address', field: 'address',width: 100, sortable: true };
export let colCity = {colId: 'city', headerName: 'City', field: 'city', width: 100, sortable: true};
export let colState = {colId: 'state', headerName: 'State', field: 'state',width: 100, sortable: true};
export let colZip = {colId: 'zip', headerName: 'Zip', field: 'zip',width: 100, sortable: true};
export let colPrimaryPhone = {colId: 'primaryPhone', headerName: 'Primary Phone', field: 'phonePrimary',width: 100, sortable: true};
export let colSecondaryPhone = {colId: 'secondaryPhone', headerName: 'Secondary Phone', field: 'phoneSecondary',width: 100, sortable: true};
export let colAnnualRevenues = {colId: 'annualRevenues', headerName: 'Annual Revenues', field: 'annualRevenues',width: 100, sortable: true};
export let colDunsNum = {colId: 'dunsNum', headerName: 'Duns Number', field: 'dunsNum',width: 100, sortable: true};
export let colNpiNum = {colId: 'npiNum', headerName: 'NPI #', field: 'npiNum',width: 50, sortable: true};

export let colPartyType = {
                            colId: 'partyType', 
                            headerName: 'Party Type', 
                            field: 'partyType',
                            width: 50, 
                            sortable: true
                          };

export let colNumEmployees = {colId: 'numEmployees', headerName: 'Number of Employees', field: 'numEmployees',width: 100, sortable: true};
export let colStanding = {colId: 'standing', headerName: 'Standing', field: 'standing',width: 100, sortable: true};
export let colTaxExemptNum = {colId: 'taxExemptNum',
                                headerName: 'Tax Exempt Certificate #', field: 'taxExemptNum',width: 100, sortable: true};
export let colPublicOrPrivate = {colId: 'privatePublic', headerName: 'Public/Private', field: 'publicOrPrivate',width: 100, sortable: true};
export let colCcnNum = {colId: 'ccnNum', headerName: 'CCN #', field: 'ccnNum',width: 100, sortable: true};
export let colProfitOrNot = {colId: 'profitOrNot', headerName: 'Profit/Non-Profit', field: 'nonOrForProfit',width: 100, sortable: true};
export let colDescription = {colId: 'description', headerName: 'Description', field: 'description',width: 100, sortable: true};
export let colDba = {colId: 'dba', headerName: 'DBA', field: 'dba',width: 100, sortable: true};
export let colFormallyKnownAs = {colId: 'formallyKnownAs',
                                    headerName: 'Formally Known As', field: 'formallyKnownAs',width: 100, sortable: true};
export let colFax = {colId: 'fax', headerName: 'Fax', field: 'fax', width: 50, sortable: true};
export let colCoiRequired = {colId: 'coiRequired', headerName: 'Missing COI', field: 'coiRequired', width: 50, sortable: true};
export let colBaaRequired = {colId: 'baaRequired', headerName: 'Missing BAA', field: 'baaRequired', width: 50, sortable: true};
export let colRiskScore = {colId: 'riskScore', headerName: 'Risk Score', field: 'riskScore', width: 50, sortable: true};

export let colCountry = {
                          colId: 'country',
                          headerName: 'Country',
                          field: 'country',
                          width: 100,
                          sortable: true
                        };

export let colCounty = {
  colId: 'county',
  headerName: 'County',
  field: 'county',
  width: 100,
  sortable: true
};

// Tax & Compliance Columns
export let colFein = {
  colId: 'fein',
  headerName: 'FEIN',
  field: 'fein',
  width: 100,
  sortable: true
};

export let colGlAccountNumber = {
  colId: 'glAccountNumber',
  headerName: 'G/L Account #',
  field: 'glAccountNumber',
  width: 100,
  sortable: true
};

export let colBusinessStructure = {
  colId: 'businessStructure',
  headerName: 'Business Structure',
  field: 'businessStructure',
  width: 120,
  sortable: true
};

export let colCategory1099 = {
  colId: 'category1099',
  headerName: '1099 Category',
  field: 'category1099',
  width: 100,
  sortable: true
};

export let colLicenseType = {
  colId: 'licenseType',
  headerName: 'License Type',
  field: 'licenseType',
  width: 100,
  sortable: true
};

export let colDiversityStanding = {
  colId: 'diversityStanding',
  headerName: 'Diversity Standing',
  field: 'diversityStanding',
  width: 120,
  sortable: true
};

export let colDe542 = {
  colId: 'de542',
  headerName: 'DEA 542',
  field: 'de542',
  width: 80,
  sortable: true,
  valueFormatter: (params: any) => params.value ? 'Yes' : 'No'
};

export let colOigScreening = {
  colId: 'oigScreening',
  headerName: 'OIG Screening',
  field: 'oigScreening',
  width: 100,
  sortable: true,
  valueFormatter: (params: any) => params.value ? 'Yes' : 'No'
};

export let colAncillary = {
  colId: 'ancillary',
  headerName: 'Ancillary',
  field: 'ancillary',
  width: 80,
  sortable: true,
  valueFormatter: (params: any) => params.value ? 'Yes' : 'No'
};

// W9 Address Columns
export let colW9StreetAddress1 = {
  colId: 'w9StreetAddress1',
  headerName: 'W9 Address 1',
  field: 'w9StreetAddress1',
  width: 150,
  sortable: true
};

export let colW9StreetAddress2 = {
  colId: 'w9StreetAddress2',
  headerName: 'W9 Address 2',
  field: 'w9StreetAddress2',
  width: 150,
  sortable: true
};

export let colW9City = {
  colId: 'w9City',
  headerName: 'W9 City',
  field: 'w9City',
  width: 100,
  sortable: true
};

export let colW9State = {
  colId: 'w9State',
  headerName: 'W9 State',
  field: 'w9State',
  width: 80,
  sortable: true
};

export let colW9Zip = {
  colId: 'w9Zip',
  headerName: 'W9 ZIP',
  field: 'w9Zip',
  width: 80,
  sortable: true
};

// Invoice Remittance Address Columns
export let colRemittanceStreetAddress1 = {
  colId: 'remittanceStreetAddress1',
  headerName: 'Remittance Address 1',
  field: 'remittanceStreetAddress1',
  width: 150,
  sortable: true
};

export let colRemittanceStreetAddress2 = {
  colId: 'remittanceStreetAddress2',
  headerName: 'Remittance Address 2',
  field: 'remittanceStreetAddress2',
  width: 150,
  sortable: true
};

export let colRemittanceCity = {
  colId: 'remittanceCity',
  headerName: 'Remittance City',
  field: 'remittanceCity',
  width: 100,
  sortable: true
};

export let colRemittanceState = {
  colId: 'remittanceState',
  headerName: 'Remittance State',
  field: 'remittanceState',
  width: 100,
  sortable: true
};

export let colRemittanceZip = {
  colId: 'remittanceZip',
  headerName: 'Remittance ZIP',
  field: 'remittanceZip',
  width: 100,
  sortable: true
};

export let colPrintCheckAs = {
  colId: 'printCheckAs',
  headerName: 'Print Check As',
  field: 'printCheckAs',
  width: 150,
  sortable: true
};

export let colPaymentTerms = {
  colId: 'paymentTerms',
  headerName: 'Payment Terms',
  field: 'paymentTerms',
  width: 100,
  sortable: true
};

// Secondary Address Columns
export let colSecondaryAddress = {
  colId: 'secondaryAddress',
  headerName: 'Secondary Address',
  field: 'secondaryAddress',
  width: 150,
  sortable: true
};

export let colSecondaryCity = {
  colId: 'secondaryCity',
  headerName: 'Secondary City',
  field: 'secondaryCity',
  width: 100,
  sortable: true
};

export let colSecondaryState = {
  colId: 'secondaryState',
  headerName: 'Secondary State',
  field: 'secondaryState',
  width: 100,
  sortable: true
};

export let colSecondaryZip = {
  colId: 'secondaryZip',
  headerName: 'Secondary ZIP',
  field: 'secondaryZip',
  width: 80,
  sortable: true
};

// Team Assignment Columns
export let colOwner = {
  colId: 'owner',
  headerName: 'Owner',
  field: 'owner',
  width: 120,
  sortable: true,
  valueGetter: (params: any) => {
    const owner = params.data?.owner;
    if (!owner) return '';
    if (typeof owner === 'object' && owner.userData) {
      const { given_name, family_name, email } = owner.userData;
      return (given_name && family_name) ? `${family_name}, ${given_name}` : (email || '');
    }
    if (typeof owner === 'object' && owner.shortFriendlyName) return owner.shortFriendlyName;
    if (typeof owner === 'object' && owner.email) return owner.email;
    if (typeof owner === 'string') return owner;
    return '';
  }
};

export let colAssessor = {
  colId: 'assessor',
  headerName: 'Assessor',
  field: 'assessor',
  width: 120,
  sortable: true,
  valueGetter: (params: any) => {
    const assessor = params.data?.assessor;
    if (!assessor) return '';
    if (typeof assessor === 'object' && assessor.userData) {
      const { given_name, family_name, email } = assessor.userData;
      return (given_name && family_name) ? `${family_name}, ${given_name}` : (email || '');
    }
    if (typeof assessor === 'object' && assessor.shortFriendlyName) return assessor.shortFriendlyName;
    if (typeof assessor === 'object' && assessor.email) return assessor.email;
    if (typeof assessor === 'string') return assessor;
    return '';
  }
};

export let colFinalReviewer = {
  colId: 'finalReviewer',
  headerName: 'Final Reviewer',
  field: 'finalReviewer',
  width: 120,
  sortable: true,
  valueGetter: (params: any) => {
    const reviewer = params.data?.finalReviewer;
    if (!reviewer) return '';
    if (typeof reviewer === 'object' && reviewer.userData) {
      const { given_name, family_name, email } = reviewer.userData;
      return (given_name && family_name) ? `${family_name}, ${given_name}` : (email || '');
    }
    if (typeof reviewer === 'object' && reviewer.shortFriendlyName) return reviewer.shortFriendlyName;
    if (typeof reviewer === 'object' && reviewer.email) return reviewer.email;
    if (typeof reviewer === 'string') return reviewer;
    return '';
  }
};

export let allColumns = [

    colVendorNum,
    colVendorName,
    colAccountingCompanyName,
    colWebsite,
    colParentParty,
    colSpecialty,
    colTin,
    colAddress,
    colCity,
    colState,
    colZip,
    colCountry,
    colCounty,
    colPrimaryPhone,
    colSecondaryPhone,
    colAnnualRevenues,
    colDunsNum,
    colNpiNum,
    colPartyType,
    colNumEmployees,
    colStanding,
    colTaxExemptNum,
    colPublicOrPrivate,
    colCcnNum,
    colProfitOrNot,
    colDescription,
    colDba,
    colFormallyKnownAs,
    colFax,
    colCoiRequired,
    colBaaRequired,
    colRiskScore,
    // Tax & Compliance
    colFein,
    colGlAccountNumber,
    colBusinessStructure,
    colCategory1099,
    colLicenseType,
    colDiversityStanding,
    colDe542,
    colOigScreening,
    colAncillary,
    // W9 Address
    colW9StreetAddress1,
    colW9StreetAddress2,
    colW9City,
    colW9State,
    colW9Zip,
    // Invoice Remittance
    colRemittanceStreetAddress1,
    colRemittanceStreetAddress2,
    colRemittanceCity,
    colRemittanceState,
    colRemittanceZip,
    colPrintCheckAs,
    colPaymentTerms,
    // Secondary Address
    colSecondaryAddress,
    colSecondaryCity,
    colSecondaryState,
    colSecondaryZip,
    // Team Assignment
    colOwner,
    colAssessor,
    colFinalReviewer
]




export let columnSelectList = [
    {
      value: colVendorNum,
      viewValue: colVendorNum.headerName
    },
    {
      value: colVendorName,
      viewValue: colVendorName.headerName
    },
    {
      value: colWebsite,
      viewValue: colWebsite.headerName
    },
    {
      value: colParentParty,
      viewValue: colParentParty.headerName
    },
    {
      value: colSpecialty,
      viewValue: colSpecialty.headerName
    },
    {
      value: colTin,
      viewValue: colTin.headerName
    },
    {
      value: colAddress,
      viewValue: colAddress.headerName
    },
    {
      value: colCity,
      viewValue: colCity.headerName
    },
    {
      value: colState,
      viewValue: colState.headerName
    },
    {
      value: colZip,
      viewValue: colZip.headerName
    },
    {
      value: colCountry,
      viewValue: colCountry.headerName
    },
    {
      value: colPrimaryPhone,
      viewValue: colPrimaryPhone.headerName
    },
    {
      value: colSecondaryPhone,
      viewValue: colSecondaryPhone.headerName
    },
    {
      value: colAnnualRevenues,
      viewValue: colAnnualRevenues.headerName
    },
    {
      value: colDunsNum,
      viewValue: colDunsNum.headerName
    },
    {
      value: colNpiNum,
      viewValue: colNpiNum.headerName
    },
    {
      value: colPartyType,
      viewValue: colPartyType.headerName
    },
    {
      value: colNumEmployees,
      viewValue: colNumEmployees.headerName
    },
    {
      value: colStanding,
      viewValue: colStanding.headerName
    },
    {
      value: colTaxExemptNum,
      viewValue: colTaxExemptNum.headerName
    },
    {
      value: colPublicOrPrivate,
      viewValue: colPublicOrPrivate.headerName
    },
    {
      value: colCcnNum,
      viewValue: colCcnNum.headerName
    },
    {
      value: colProfitOrNot,
      viewValue: colProfitOrNot.headerName
    },
    {
      value: colDescription,
      viewValue: colDescription.headerName
    },
    {
      value: colDba,
      viewValue: colDba.headerName
    },
    {
      value: colFormallyKnownAs,
      viewValue: colFormallyKnownAs.headerName
    },
    {
      value: colFax,
      viewValue: colFax.headerName
    },
    {
      value: colBaaRequired,
      viewValue: colBaaRequired.headerName
    },
    {
      value: colCoiRequired,
      viewValue: colCoiRequired.headerName
    },
    {
      value: colRiskScore,
      viewValue: colRiskScore.headerName
    },
    // Tax & Compliance
    {
      value: colFein,
      viewValue: colFein.headerName
    },
    {
      value: colGlAccountNumber,
      viewValue: colGlAccountNumber.headerName
    },
    {
      value: colBusinessStructure,
      viewValue: colBusinessStructure.headerName
    },
    {
      value: colCategory1099,
      viewValue: colCategory1099.headerName
    },
    {
      value: colLicenseType,
      viewValue: colLicenseType.headerName
    },
    {
      value: colDiversityStanding,
      viewValue: colDiversityStanding.headerName
    },
    {
      value: colDe542,
      viewValue: colDe542.headerName
    },
    {
      value: colOigScreening,
      viewValue: colOigScreening.headerName
    },
    {
      value: colAncillary,
      viewValue: colAncillary.headerName
    },
    // W9 Address
    {
      value: colW9StreetAddress1,
      viewValue: colW9StreetAddress1.headerName
    },
    {
      value: colW9StreetAddress2,
      viewValue: colW9StreetAddress2.headerName
    },
    {
      value: colW9City,
      viewValue: colW9City.headerName
    },
    {
      value: colW9State,
      viewValue: colW9State.headerName
    },
    {
      value: colW9Zip,
      viewValue: colW9Zip.headerName
    },
    // Invoice Remittance
    {
      value: colRemittanceStreetAddress1,
      viewValue: colRemittanceStreetAddress1.headerName
    },
    {
      value: colRemittanceStreetAddress2,
      viewValue: colRemittanceStreetAddress2.headerName
    },
    {
      value: colRemittanceCity,
      viewValue: colRemittanceCity.headerName
    },
    {
      value: colRemittanceState,
      viewValue: colRemittanceState.headerName
    },
    {
      value: colRemittanceZip,
      viewValue: colRemittanceZip.headerName
    },
    {
      value: colPrintCheckAs,
      viewValue: colPrintCheckAs.headerName
    },
    {
      value: colPaymentTerms,
      viewValue: colPaymentTerms.headerName
    },
    {
      value: colCounty,
      viewValue: colCounty.headerName
    },
    // Secondary Address
    {
      value: colSecondaryAddress,
      viewValue: colSecondaryAddress.headerName
    },
    {
      value: colSecondaryCity,
      viewValue: colSecondaryCity.headerName
    },
    {
      value: colSecondaryState,
      viewValue: colSecondaryState.headerName
    },
    {
      value: colSecondaryZip,
      viewValue: colSecondaryZip.headerName
    },
    // Team Assignment
    {
      value: colOwner,
      viewValue: colOwner.headerName
    },
    {
      value: colAssessor,
      viewValue: colAssessor.headerName
    },
    {
      value: colFinalReviewer,
      viewValue: colFinalReviewer.headerName
    }
  ];
